import * as React from "react"
import DatePicker from "react-datepicker";
import { IDiagnosticLabTestItem } from "@curefit/care-common";
import { ChangeEvent } from "react" 
import { AppConstants, AppMessages, AppPlaceholders } from "../../utils/AppConstants";
import IStaticDataValue from "../../../../common/models/IStaticDataValue";
import ModelFactory from "../../models/ModelFactory";
import * as _ from "lodash";
import CustomSelect from "../CustomSelect";
import TypeAhead, { TypeAheadElement, TypeAheadResults } from "../TypeAhead";
import IDiagnosticSuggestions from "../../models/IDiagnosticSuggestions";
import * as $ from "jquery";
import TextAreaAutoResize from "../TextAreaAutoResize";
import TextInput from "../TextInput";
import AppUtils from "../../utils/AppUtils";
import * as moment from "moment";
/**
 * Created by aditya on 06/02/18.
 */

export interface DiagnosticLabTestItemEditorProps {
    patientId: number,
    curefitUserId: number;
    consultationType: string,
    fetchStaticLabTestsData: (input: string) => Promise<any>,
    fetchStaticDiagnosticLabTests: (input: string) => Promise<any>
    item: IDiagnosticLabTestItem;
    onDataChange: (updatedItem: IDiagnosticLabTestItem) => any,
}

export interface DiagnosticLabTestItemEditorState {
    validate: boolean;
    labTestNameWarning: boolean;
    fetchedMatchedMetrics: IDiagnosticSuggestions[]
}

class DiagnosticLabTestItemEditor extends React.Component<DiagnosticLabTestItemEditorProps, DiagnosticLabTestItemEditorState> {
    private labTestItemDOM: any;
    constructor(props: DiagnosticLabTestItemEditorProps) {
        super(props);
        let showLabTestWarning = ModelFactory.isValidLabTest(props.item);
        this.state = {
            validate: false,
            labTestNameWarning: showLabTestWarning,
            fetchedMatchedMetrics: []
        }
    }


    onLabTestTypeAheadChange = (input: string) => {
        let myInstance = this;
        let typeAheadResults: TypeAheadResults;
        let typeAheadArray: TypeAheadElement[] = [];

        // Default selections to avoid breaking of UI because backend does not do any validation
        // and because of that on refresh of the page frontend breaks and keeps showing loading page,
        // that is because of incorrect data stored in DB
        // @TODO: This should be replaced with proper validation at frontend or backend side (Chetan Vekariya)
        let staticDataItem = ModelFactory.createNewStaticItem();
        staticDataItem.internalValue = "";
        staticDataItem.displayValue = AppConstants.LabtestUnits[""];
        const formattedDate = this.props.item && this.props.item.metricDate ? this.props.item.metricDate : moment().valueOf();

        let updatedItem = { ...this.props.item, name: input, code: "UNKNOWN", testCondition: staticDataItem, metricDate: formattedDate };
        this.props.onDataChange(updatedItem);
        this.setState({
            labTestNameWarning: false
        })

        // Call the api for every typed letter and bring only matched characters
        return this.props.fetchStaticDiagnosticLabTests(input).then((results: IDiagnosticSuggestions[]): Promise<TypeAheadResults> => {
            if (results.length > 0) {
                myInstance.setState({fetchedMatchedMetrics: results});
                results.forEach((diagnostic: IDiagnosticSuggestions) => {
                    let additionalInfoLabel = !_.isEmpty(diagnostic.alternateNames) ? diagnostic.alternateNames.join(" | ") : undefined;
                    let typeAheadElement = {
                        value: diagnostic.code,
                        label: diagnostic.name,
                        metricId: diagnostic.id,
                        additionalInfoLabel: additionalInfoLabel
                    }
                    typeAheadArray.push(typeAheadElement);
                })
                typeAheadResults = {options: typeAheadArray, completed: true};
                return Promise.resolve(typeAheadResults);
            } else {
                return Promise.resolve({options: [], completed: false});
            }
        }).catch((error: any) => {
            console.error(error);
            return Promise.resolve({options: [], completed: false});
        });

    };

    onLabTestTypeAheadSelect = (elem: TypeAheadElement & { metricId?: number }) => {
        let unit = this.state.fetchedMatchedMetrics.filter((labTest: IDiagnosticSuggestions) => labTest.name === elem.label)[0].unit
        let staticDataItem = ModelFactory.createNewStaticItem();
        staticDataItem.internalValue = unit;
        staticDataItem.displayValue = AppConstants.LabtestUnits[unit];
        let updatedItem: IDiagnosticLabTestItem = { ...this.props.item, name: elem.label, code: elem.value, source: "LAB_REPORT",  metricId: elem.metricId, userId: this.props.curefitUserId, subUserId: this.props.patientId, testCondition: staticDataItem };
        // updatedItem = { ...this.props.item, testCondition: staticDataItem };
        this.props.onDataChange(updatedItem);
    };

    onLabTestInstructionChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
        let updatedItem = Object.assign({}, this.props.item, { sourceMetadata: { source: event.target.value} });
        this.props.onDataChange(updatedItem);
    };

    onLabTestRecordedValueChange = (event: ChangeEvent<HTMLInputElement>) => {
        let recordedValue = event.target.value;
        let updatedItem = { ...this.props.item, value: recordedValue };
        this.props.onDataChange(updatedItem);
    };

    handleLabTestNameBlur = (event: any) => {
        this.setState({
            labTestNameWarning: true
        })
    }

    generateConditionList() {
        let conditionList: IStaticDataValue[] = [];
        _.map(AppConstants.LabtestConditions, (type, key) => {
            let condition = ModelFactory.createNewStaticItem();
            condition.internalValue = key;
            condition.displayValue = type;
            conditionList.push(condition);
        })
        return conditionList;
    }

    generateUnitList() {
        let unitList: IStaticDataValue[] = [];
        _.map(AppConstants.LabtestUnits, (type, key) => {
            let condition = ModelFactory.createNewStaticItem();
            condition.internalValue = key;
            condition.displayValue = type;
            unitList.push(condition);
        })
        return unitList;

    }

    handleDateChange = (date?: any) => {
        const formattedDate = date.valueOf();
        let updatedItem = { ...this.props.item, metricDate: formattedDate };
        this.props.onDataChange(updatedItem);
    };


    handleDateOnBlur = (e: any) => {
        const date: string = e.target.value;
        if (moment(date, AppConstants.reverseDateFormat).isValid()) return;
        else {
            this.handleDateChange();
        }
    };

    render() {
        let labTestName = this.props.item && !_.isNil(this.props.item.name) ? this.props.item.name : this.props.item.metric ? this.props.item.metric.name : "";
        let labTestInstruction = !_.isEmpty(this.props.item.sourceMetadata) ? this.props.item.sourceMetadata.source : "";
        let labtestUnits = this.generateUnitList();
        let selectedCondition = !_.isEmpty(this.props.item.testCondition) ? this.props.item.testCondition.internalValue : this.props.item.metric ? this.props.item.metric.unit : null;
        let labTestRecordedValue = this.props.item.value ? this.props.item.value : "";
        let labTestNameValidationStatus = this.state.validate && _.isEmpty(this.props.item.name) ? "error" : "";
        let labTestNameWarning = this.state.labTestNameWarning && this.props.item.code === "UNKNOWN" ? AppMessages.LAB_TEST_UNKNOWN_TEST_ERROR_MESSAGE : null;
        const recordedDate = !_.isEmpty(this.props.item) && AppUtils.isDefined(this.props.item.metricDate) ? moment(this.props.item.metricDate) : null;

        return (
            <div className="diagnostic-labTest-item-editor" ref={(labTestItemDOM) => this.labTestItemDOM = labTestItemDOM}>
            <div className={`diagnostic-labTest-editor-name ${labTestNameValidationStatus}`}>
                <TypeAhead widgetName={"DiagnosticLabTestItem"} name={"diagnostic-labTest-name"} value={labTestName} placeholder={AppPlaceholders.DIAGNOSIS_EDITVIEW_NAME} onTypeAheadChange={this.onLabTestTypeAheadChange} onTypeAheadSelect={this.onLabTestTypeAheadSelect}
                        onTypeAheadBlur={this.handleLabTestNameBlur} errorText={labTestNameWarning} />
            </div>
            <div className="diagnosticlabTest-editor-value">
               <TextInput type="number" name="diagnostic-labTest-name" value={labTestRecordedValue || ""} onChange={this.onLabTestRecordedValueChange} placeholder={AppPlaceholders.LAB_TESTS_EDITVIEW_RECORDED_VALUE} />
            </div>
            <div className="diagnostic-labTest-editor-unit health-target-item-editor-metric" >
                <TextInput disabled={true} name="diagnostic-labTest-unit" value={selectedCondition || ""} />
            </div>
            <div className = {"recorded-date-input-wrapper"}>
                    <DatePicker
                        placeholderText={"Recorded Date"}
                        onChange={this.handleDateChange}
                        dateFormat={AppConstants.reverseDateFormat}
                        onBlur={this.handleDateOnBlur}
                        selected={recordedDate}
                    />
                </div>
            <div>
            <TextAreaAutoResize
                        name={"diagnostic-labTest-editor-instructions"}
                        className={"textarea-input form-control"}
                        value={labTestInstruction}
                        placeholder={AppPlaceholders.DIAGNOSTIC_LAB_TESTS_EDITVIEW_REMARKS}
                        onChange={this.onLabTestInstructionChange}
                    />
            </div>
        </div>
        )
    }
}

export default DiagnosticLabTestItemEditor;
